import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaTiktok,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhone,
  FaWhatsapp,
  FaClock,
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* About */}
          <div>
            <div className="flex items-center gap-2.5 mb-4 group">
              <img
                src="/logo.png"
                alt="Waziri Mobile Logo"
                className="h-10 w-10 object-contain bg-white rounded-full p-0.5"
              />
              <span className="text-xl font-bold text-white">
                Waziri<span className="text-primary-500">Mobile</span>
              </span>
            </div>
            <p className="text-gray-400 mb-4">
              Your trusted partner for premium smartphones and accessories.
              Quality products with warranty and expert support.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/share/1HRFYvPFB8/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-500 transition-colors"
              >
                <FaFacebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/waziri_mobile_46?igsh=MWdpZ2hlamJwYnQ5NA=="
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-500 transition-colors"
              >
                <FaInstagram size={20} />
              </a>
              <a
                href="https://www.tiktok.com/@wazirimobile46?_r=1&_t=ZS-96XiBCx3w1N"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-500 transition-colors"
              >
                <FaTiktok size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-primary-500 transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  className="text-gray-400 hover:text-primary-500 transition-colors"
                >
                  Products
                </Link>
              </li>
              <li>
                <Link
                  to="/accessories"
                  className="text-gray-400 hover:text-primary-500 transition-colors"
                >
                  Accessories
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-primary-500 transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-primary-500 transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Popular Categories</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/products?brand=Apple"
                  className="text-gray-400 hover:text-primary-500 transition-colors"
                >
                  iPhone
                </Link>
              </li>
              <li>
                <Link
                  to="/products?brand=Samsung"
                  className="text-gray-400 hover:text-primary-500 transition-colors"
                >
                  Samsung
                </Link>
              </li>
              <li>
                <Link
                  to="/products?brand=Xiaomi"
                  className="text-gray-400 hover:text-primary-500 transition-colors"
                >
                  Xiaomi
                </Link>
              </li>
              <li>
                <Link
                  to="/products?brand=OnePlus"
                  className="text-gray-400 hover:text-primary-500 transition-colors"
                >
                  OnePlus
                </Link>
              </li>
              <li>
                <Link
                  to="/products?brand=Google"
                  className="text-gray-400 hover:text-primary-500 transition-colors"
                >
                  Google Pixel
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <FaMapMarkerAlt className="text-primary-500 mt-1" />
                <span className="text-gray-400">
                  Waziri Mobile Shop, Near Ali Plaza Hussaini Chowk Skardu
                </span>
              </li>
              <li className="flex items-center gap-3">
                <FaPhone className="text-primary-500" />
                <span className="text-gray-400">+92 348 8477649</span>
              </li>
              <li className="flex items-center gap-3">
                <FaPhone className="text-primary-500" />
                <span className="text-gray-400">+92 346 4411344</span>
              </li>
              <li className="flex items-center gap-3">
                <FaWhatsapp className="text-primary-500" />
                <a
                  href="https://wa.me/923488477649"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-primary-500 transition-colors"
                >
                  WhatsApp: +92 348 8477649
                </a>
              </li>
              <li className="flex items-start gap-3">
                <FaClock className="text-primary-500 mt-1" />
                <span className="text-gray-400">
                  Mon-Sat: 10AM - 8PM
                  <br />
                  Sunday: Closed
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400">
            &copy; {currentYear} Waziri Mobile. All rights reserved. <br />
            Designed & Developed by SaroHub Technologies (Private) limited.
            <br />
            <a
              href="https://sarohub.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-500 hover:text-primary-400 transition-colors"
            >
              sarohub.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
